import * as React from "react";

function IcSystemCrossClose12(props) {
  const {
    accentColor: accent = "#0194F3",
    color = "#687176",
    width = 12,
    height = 12,
    title,
    titleId,
  } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-id="IcSystemCrossClose12"
      aria-labelledby={titleId}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M2 2L10 10M10 2L2 10"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default IcSystemCrossClose12;
